import React from 'react';
import { createPortal } from 'react-dom';
import { Calculator, X } from 'lucide-react';
import { months } from './utils/payrollConstants';

interface GeneratePayrollDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedMonth: number;
  selectedYear: number;
  isGenerating: boolean;
}

export default function GeneratePayrollDialog({
  open,
  onClose,
  onConfirm,
  selectedMonth,
  selectedYear,
  isGenerating,
}: GeneratePayrollDialogProps) {
  if (!open) return null;

  const monthLabel = months.find(m => m.value === selectedMonth)?.label || '';

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 animate-fadeIn">
        <button
          onClick={onClose}
          disabled={isGenerating}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 disabled:opacity-50"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center">
            <Calculator className="w-6 h-6 text-emerald-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Generate Payroll</h3>
          </div>
        </div>
        <p className="text-gray-600 mb-2">
          Apakah Anda yakin ingin generate payroll untuk periode:
        </p>
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <p className="text-center font-semibold text-lg text-gray-900">
            {monthLabel} {selectedYear}
          </p>
        </div>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-6">
          <p className="text-sm text-amber-800">
            <strong>Perhatian:</strong> Payroll draft yang sudah ada untuk periode ini akan dihapus
            dan diganti dengan data baru.
          </p>
        </div>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isGenerating}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            disabled={isGenerating}
            className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors disabled:opacity-50 flex items-center gap-2"
          >
            <Calculator className="w-4 h-4" />
            {isGenerating ? 'Generating...' : 'Generate'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
